<template>
    <div class="error-msg-wrap">
        <!-- Same look as a new meeting item (AddEditMeetingItem.vue) -->
        <div class="form-wrapper slide-up crm-form-wrapper crm-form-new">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div class="qc-item-wrap crm-item-wrap crm-item-wrap-bare">
                <div>
                    <h3 v-if="heading" class="quick-add-heading">{{ heading }}</h3>
                    <div class="crm-item-label" style="margin-top:0">Name</div>
                    <input type="text" style="margin:0 0 15px" v-model="formData.Name" ref="nameInput" @keyup.enter="submit()" />

                    <div v-if="displayTags.length" class="customer-request-tags">
                        <div v-for="(tag, i) in displayTags" :key="i" :style="'background:'+tag.color">{{ tag.name }}</div>
                    </div>
                    <div v-if="allTags.length" class="board-item-btns">
                        <div>
                            <span @click="() => { showTags = !showTags; }">Tags</span>
                            <div v-if="showTags" class="board-item-tags">
                                <div class="board-item-tags-close" @click="() => { showTags = false }"><svg-icon icon="x" /></div>
                                <div class="board-item-tags-tags">
                                    <div v-for="(tag, i) in allTags" :key="i" class="checkbox-input customer-request-tag" :style="'background:'+tag.color">
                                        <input style="margin-left: 10px" type="checkbox" v-model="tag.checked" />
                                        <span>{{ tag.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="crm-item-label">Description</div>
                    <div class="board-tip-tap">
                        <tip-tap v-model="formData.Description" :hide-h3="true" :hide-h4="true" :hide-table="true" />
                    </div>

                    <input style="margin-top:20px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import SvgIcon from '@/components/SvgIcon.vue';
import TipTap from '@/components/TipTap.vue';

export default defineComponent({
    name: 'AddNewCompanyBoardItem',
    // heading: optional title above the form (the header's quick add uses it)
    props: [ 'item', 'tags', 'heading' ],
    emits: [ 'close' ],
    components: {
        SvgIcon,
        TipTap
    },
    data() {
        return {
            disableButton: false,
            formData: {} as any,
            allTags: [] as any,
            showTags: false
        }
    },
    computed: {
        displayTags(): any[] {
            return this.allTags.filter((t: any) => t.checked);
        }
    },
    created() {
        this.formData = JSON.parse(JSON.stringify(this.$props.item));
        this.allTags = JSON.parse(JSON.stringify(this.$props.tags || []));
    },
    mounted() {
        (this.$refs.nameInput as HTMLInputElement)?.focus();
    },
    methods: {
        async submit() {
            if(!this.formData.Name) {
                alert('Include name');
                return;
            }
            if(this.disableButton) {
                return;
            }

            this.disableButton = true;
            this.formData.TagsJSON = this.displayTags.map((t: any) => t.name);

            // Responds with the new card's ID, which the board opens next
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems`, this.formData)
                .then(resp => {
                    this.$emit('close', resp.data);
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error')
                })

            this.disableButton = false;
        }
    }
});
</script>
